import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz44 = () => {
    return (
        <div>
     <NavLink to='/category/Puzzels/Puzzel45'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Last page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel43'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title"> Girl or Boy</h1>
   
    <div class="text">
        <p style={{textAlign:"justify"}}>The <strong>Boy or Girl problem</strong> consists of a bunch of questions in
            probability which has kept the mathematicians on discussion about its possibilities.&nbsp; But different
            from them, here is one puzzle for you with no ambiguity.</p>
        <p style={{textAlign:"justify"}}>Suppose that I have a friend whose name is Ankur. Ankur has his elder brother who
            got married 10 years before. But Ankur being a silly guy has the habit of forgetting things; you can say a
            “Short time memory loss”. This summer he is going to meet his brother after 10 years, and he has planned to
            purchase some clothes for his brother’s kids as a token of love. Each and every time he faces a problem he
            comes to me, so this time also, he came to seek help, and I have not left him empty handed. I told him that
            as far as I can recall, his brother has two offspring’s and one of the boy&nbsp;was born on Tuesday. Now,
            it’s your turn to help him. &nbsp;What is the probability that Ankur’s brother has two boys? Assume an equal
            chance of giving birth to either sex and an equal chance to giving birth on any day.</p>
        <p>&nbsp;</p>
        <p style={{textAlign:"justify"}}><strong>Solution</strong>: If you think the answer should be 1/2, you would be
            wrong. If you knew which child was a boy (say, the younger one), you would be closer to the truth.But since
            the boy could be either the younger or the older child, the analysis is more subtle. The answer would be
            13/27.</p>
        <p style={{textAlign:"justify"}}>There can be four cases, i.e. either his brother has two boys, or one boy(elder)
            and one girl, one girl(elder) and one boy, or both of them are girls. And there are 7 equally likely
            possibilities for any one of the children of taking birth on Tuesday for all these four cases. Therefore,
            the total cases are 7×4- 1(as there is repetition of two boys two times). The possibility for having two
            boys with both of them taking birth on Tuesday will be 7×2- 1. Therefore, the answer would be 13/27. The
            things can be made more clear from the image shown below.<br/><img
                class="aligncenter size-full wp-image-25728"
                src="https://media.geeksforgeeks.org/wp-content/uploads/child.jpg" alt="puzz" width="566" height="464"/>
        </p>
       
    </div>
</article>
        </div>
    )
}

export default Puz44
